<template>
  <form-dialog :dialogVisible="openTemAdd" @closeDialog="closeTemAdd"
    :title="`${addEdit === 'ADD' ? $t('nstm19') : $t('cspm5')}${$t('nstm48')}`">
    <div class="form-item">
      <el-form ref="form" :rules="addEdit === 'ADD' ? rules : editRules" :model="form" label-width="80px">
        <el-form-item :label="$t('cdt32')" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('nstm49')" prop="description">
          <el-input type="textarea" v-model="form.description"></el-input>
        </el-form-item>

        <el-form-item :label="$t('cdcp20')" prop="screen_type">
          <el-select v-model="form.s_type" :placeholder="$t('nstm50')">
            <el-option v-for="item in screenList" :key="item.id" :value="item.type" :label="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="屏幕类型" prop="screen_type" v-if="false">
          <el-select v-model="form.screen_type" placeholder="请选择屏幕类型">
            <el-option v-for="item in screenTypes" :key="item.type" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="屏幕方向" prop="screen_orientation" v-if="false">
          <el-select v-model="form.screen_orientation" placeholder="请选择屏幕方向">
            <el-option v-for="item in screenOrientation" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item :label="$t('nstm51')" prop="tempZip" v-if="addEdit === 'ADD'">
          <el-upload class="upload-demo" ref="upload" :action="`${baseURL}/admin/template/upTemplateFile`" accept=".zip"
            :limit="1" :data="uploadFile" :file-list="templateFileList" :before-upload="handlePreview"
            :on-success="handle_success">
            <el-button size="small" type="primary">{{ $t('nstm52') }}</el-button>
          </el-upload>
        </el-form-item>
        <!-- <el-form-item label="缩略图" prop="thumb">
          <el-upload
            :action="`${baseURL}/admin/template/${addEdit === 'ADD' ? 'addTemplate' : 'editTemplate'}`"
            :file-list="thumbFile"
            list-type="picture"
            :limit="1"
            :data="tempData"
            :auto-upload="false"
            :before-upload="handleTemplatePreview"
            :on-change="thumpUploadChange"
            ref="uploadTemp"
          >
            <el-button type="primary">上传</el-button>
          </el-upload>
        </el-form-item> -->
        <el-form-item :label="$t('PE.Thumbnail')" prop="thumb">
          <el-upload :action="`${baseURL}/admin/template/${addEdit === 'ADD' ? 'addTemplate' : 'editTemplate'}`"
            :file-list="thumbFile" list-type="picture" :data="tempData" :auto-upload="false"
            :before-upload="handleTemplatePreview" :on-change="thumpUploadChange" :on-success="handleSuccess"
            ref="uploadTemp">
            <el-button type="primary" size="small">{{ $t('cemu2') }}</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
    </div>
    <div class="buttons">
      <el-button type="primary" @click="confirm()" round :disabled="isConfirm">{{ $t('nstm17') }}</el-button>
      <el-button @click="cancel" round>{{ $t('nstm18') }}</el-button>
    </div>
  </form-dialog>
</template>

<script>
import {
  handleDataAndSign
} from "@/assets/scripts/handleDataAndSign";
import FormDialog from "@/components/basics/FormDialog";

export default {
  name: "AddTemplate",
  props: {
    openTemAdd: {
      type: Boolean,
      required: true,
      default: false,
    },
    themeId: {
      type: Number,
    },
    addEdit: {
      type: String,
      default: "ADD"
    },
    editData: {
      type: Object,
      default: () => { }
    },
    s_type: {
      type: Number
    },
  },
  data() {
    const thumbFileValidate = (rule, value, callback) => {
      if (value) {
        callback()
      } else {
        return callback(new Error(this.$t('nstm53')));
      }
    }
    const tempZipValidate = (rule, value, callback) => {
      if (value) {
        callback()
      } else {
        return callback(new Error(this.$t('nstm54')));
      }
    }
    return {
      isConfirm: false,
      rules: {
        name: [{ required: true, message: this.$t('nstm35') }],
        description: [{ required: false }],
        thumb: [{ validator: thumbFileValidate, trigger: 'change', required: true }],
        tempZip: [{ validator: tempZipValidate, required: true, trigger: 'change', message: this.$t('nstm55') }],
      },
      editRules: {
        name: [{ required: true, message: this.$t('nstm35') }],
        description: [{ required: false }],
      },
      form: {
        name: "",
        description: "",
        screen_type: 1,
        screen_orientation: 1,
        thumb: false,
        tempZip: false,
        s_type: 1
      },
      uploadFile: {},
      templateFileList: [],
      thumbFile: [],
      tempData: {},
      baseURL: '/api',
      screenTypes: [
        { value: 1, label: 'LED' },
        { value: 2, label: 'LCD' },
      ],
      screenOrientation: [
        { value: 1, label: this.$t('nstm56') },
        { value: 2, label: this.$t('nstm57') },
      ],
      screenList: []
    };
  },
  created() {
    this.getScreenList();
  },
  methods: {
    getScreenList() {
      this.$http.post('/admin/template/getScreenList', {}, (res) => {
        this.screenList = res;
      })
    },
    closeTemAdd(isUpdate = false) {
      this.$emit("closeTemAdd", isUpdate);
      this.$refs.form.resetFields();
      this.$refs.uploadTemp.clearFiles();
    },
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.addEdit === 'ADD') {
            this.$refs.uploadTemp.submit();
          } else {
            const uploadFiles = this.$refs.uploadTemp.uploadFiles;
            if (uploadFiles.length > 0 && uploadFiles[0].status === 'ready') {
              // 重新添加了缩略图文件
              this.$refs.uploadTemp.submit();
            } else {
              // 没有重新添加缩略图文件
              const { id, name, description, screen_type, screen_orientation, s_type } = this.form;
              this.$http.post('/admin/template/editTemplate', {
                id,
                name,
                s_type,
                description,
                screen_type,
                screen_orientation
              }, () => {
                this.closeTemAdd(true);
              })
            }
          }
        } else {
          return false;
        }
      })

    },
    cancel() {
      this.closeTemAdd(false);
    },
    handlePreview() {
      let formData = {};
      let data = handleDataAndSign("/admin/template/upTemplateFile", formData);
      this.uploadFile.v = data.v;
      this.uploadFile.t = data.t;
      this.uploadFile.token = data.token;
      this.uploadFile.s = data.s;
    },
    handleTemplatePreview() {
      const { s_type } = this.form
      this.tempData.name = this.form.name;
      this.tempData.description = this.form.description;
      this.tempData.group_id = this.$cookies.get("group_id");
      this.tempData.screen_type = this.form.screen_type;
      this.tempData.screen_orientation = this.form.screen_orientation;
      this.tempData.theme_id = this.themeId;
      this.tempData.s_type = s_type;
      if (this.addEdit === 'EDIT') {
        this.tempData.id = this.form.id;
        delete this.tempData.group_id;
        delete this.tempData.theme_id;
      }
      let formData = { ...this.tempData };
      delete formData.v;
      delete formData.t;
      delete formData.token;
      delete formData.s;
      let data = handleDataAndSign(`/admin/template/${this.addEdit === 'ADD' ? 'add' : 'edit'}Template`, formData);
      this.tempData.v = data.v;
      this.tempData.t = data.t;
      this.tempData.token = data.token;
      this.tempData.s = data.s;

    },
    handle_success(response) {
      if (response.status === 1) {
        this.form.tempZip = true;
      } else {
        this.$message({
          type: 'error',
          message: response.tips
        })
      }
    },
    thumpUploadChange(file, list) {
      this.form.thumb = true;
      if (list.length > 1 && file.status !== "fail") {
        list.splice(0, 1);
      } else if (file.status === "fail") {
        list.splice(0, 1);
      }
    },
    handleSuccess(response) {
      console.log('response', response)
      if (response.status !== 1) {
        this.$message({
          type: 'warning',
          message: this.$t('nstm58')
        })
      }
      this.closeTemAdd(true);
    },
  },
  computed: {
  },
  watch: {
    s_type(v) {
      this.form.s_type = v;
    },
    editData(n) {
      if (Object.keys(n).length) {
        this.form = { ...n };
        this.thumbFile = [
          {
            name: n.name,
            url: n.thumb_url
          }
        ];
      }
    }
  },
  components: {
    FormDialog,
  },
};
</script>

<style lang="scss" scoped>
.form-item {
  padding-right: 20px;

  /deep/ .el-upload-list__item {
    transition: none;
  }
}

.buttons {
  text-align: center;
}
</style>